import { MOBILE_FULL_WIDTH_DATA_ATTRIBUTE as e } from "./constants/index.mjs";
import { IMAGE_MOBILE_FULL_WIDTH_STYLES as t } from "../../constants/default-styles.mjs";
import { ImageModeEnum as n, ImageNameEnum as r } from "./image-enum.mjs";
import { Image as i } from "./image.mjs";
import { convertStyleObjectToCss as a } from "../../utils/style-helpers.mjs";
import { createCustomImageNodeView as o } from "./custom-image.mjs";
import { getContainerWidthFromElement as s } from "./utils/get-container-width-from-element.mjs";
import { getImageAttrs as c } from "./utils/get-image-attrs.mjs";
import { getImageWithLinkHtml as l } from "./utils/get-image-with-link-html.mjs";
import { mergeAttributes as u } from "@tiptap/react";
//#region src/extensions/image-extension/inline-image.ts
var d = i.configure({ inline: !0 }).extend({
	name: r.Inline,
	inline: !0,
	addNodeView() {
		return o(this.options.maxWidth);
	},
	parseHTML() {
		return [{
			tag: "img",
			getAttrs: (e) => {
				let t = e.closest("a")?.getAttribute("href"), r = c(e), i = s(e), a = e.getAttribute("data-mobile-full-width") === "true" || !!e.closest(".is-mobile-full-width");
				return {
					imageMode: n.Inline,
					...r,
					href: t,
					containerWidth: i,
					isMobileFullWidth: a
				};
			}
		}];
	},
	renderHTML({ HTMLAttributes: { href: n, alt: r, title: i, width: o, height: s, containerWidth: c, src: d, isMobileFullWidth: f } }) {
		let p = {};
		o && s && (p.aspectRatio = `${o}/${s}`), c !== "auto" && (p.width = c);
		let m = u({
			src: d,
			alt: r,
			title: i,
			width: o,
			style: a(p)
		});
		if (f) {
			let r = l({
				...m,
				[e]: "true"
			}, { href: n });
			return [
				"span",
				[
					"head",
					{},
					[
						"style",
						{ type: "text/css" },
						t
					]
				],
				r
			];
		}
		return l(m, { href: n });
	}
});
//#endregion
export { d as InlineImage };
